const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: '#',
  title: 'Yash.',
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'Yash Saini',
  role: 'Student and a Learner',
  description:
    'As a Final year B.Tech student specializing in computer science, I am deeply immersed in exploring various aspects of this dynamic field. With a focus on becoming a successful software engineer, I am committed to mastering both theoretical concepts and practical applications. I am dedicated to learning the latest technologies, development tools, and industry best practices to excel in software development.',
  resume: 'https://example.com',
  social: {
    twitter: 'https://twitter.com/YashSainii99',
    github: 'https://github.com/YashSaini99',
    discord: 'https://discord.gg/eJEBv7mRuJ',
    linkedin:'https://www.linkedin.com/in/yash-saini-3aab02250/'
  },
}

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
    {
    name: 'zk-share',
    description:
      'A secure, privacy-focused file sharing platform with end-to-end encryption using zero-knowledge architecture.',
    stack: ['Go','Next.js','Docker','Azure','Kubernetes'],
    sourceCode: 'https://github.com/YashSaini99/zk-share',
    livePreview: 'https://zkshare.app/',
  },
  {
    name: 'sdtop',
    description:
      'A terminal-based interactive dashboard for managing and debugging systemd services on Linux.',
    stack: ['Go'],
    sourceCode: 'https://github.com/YashSaini99/sdtop',
    livePreview: 'https://github.com/YashSaini99/sdtop',
  },
  {
    name: 'NLP_CLI',
    description:
      'A CLI tool that leverages generative AI to convert natural language commands into validated, safe shell operations for system automation.',
    stack: ['Go'],
    sourceCode: 'https://github.com/YashSaini99/NLP_CLI',
    livePreview: 'https://github.com/YashSaini99/NLP_CLI',
  },
  {
    name: 'GraphAuth',
    description:
      'A Graphical Pattern Authentication System with Multi-Factor Security',
    stack: ['Go','HTML','CSS','JavaScript','MongoDB'],
    sourceCode: 'https://github.com/YashSaini99/GraphAuth',
    livePreview: 'https://github.com/YashSaini99/GraphAuth',
  },
  {
    name: 'Rex_RotH',
    description:
      'An Open Source  MultiPurpose Discord Bot Made by me by using Discord.js v12 with Moderation, fun, Music and many more features',
    stack: ['JavaScript','Discord.js','Node.js'],
    sourceCode: 'https://github.com/YashSaini99/Rex_RotH',
    livePreview: 'https://github.com/YashSaini99/Rex_RotH',
  },
   {
    name: 'gpass',
    description:
      'A Golang packge for graphical password authentication and SMTP funcnionality.',
    stack: ['Go'],
    sourceCode: 'https://github.com/YashSaini99/gpass',
    livePreview: 'https://pkg.go.dev/github.com/YashSaini99/gpass',
  },
]

const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  'Golang',
  'HTML',
  'CSS',
  'C++',
  'JavaScript',
  'React',
  'Git',
  'Docker',
  'Kubernetes',
  'Jenkins',
  'Linux',
]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'https://www.linkedin.com/in/yash-saini-3aab02250/',
}

export { header, about, projects, skills, contact }
